module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Lupfig-9267e3a15700fb5314ed2abe2a17d61d.svg";